import script from "./NewsDetail.vue?vue&type=script&setup=true&name=NewsDetail&lang=js"
export * from "./NewsDetail.vue?vue&type=script&setup=true&name=NewsDetail&lang=js"

import "./NewsDetail.vue?vue&type=style&index=0&id=00870b35&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00870b35"]])

export default __exports__